import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChapterTag, Reveal } from "./shared";

function useCountdown(target) {
  const calc = () => {
    const diff = new Date(target).getTime() - Date.now();
    const clamp = Math.max(0, diff);
    return {
      days: Math.floor(clamp / 86400000),
      hours: Math.floor((clamp % 86400000) / 3600000),
      minutes: Math.floor((clamp % 3600000) / 60000),
      seconds: Math.floor((clamp % 60000) / 1000),
    };
  };
  const [t, setT] = useState(calc);
  useEffect(() => {
    const id = setInterval(() => setT(calc()), 1000);
    return () => clearInterval(id);
  }, [target]);
  return t;
}

function Unit({ value, label }) {
  const v = String(value).padStart(2, "0");
  return (
    <div className="flex flex-col items-center" data-testid={`countdown-${label.toLowerCase()}`}>
      <div className="relative h-[16vw] overflow-hidden md:h-[11vw] lg:h-[9rem]">
        <AnimatePresence mode="popLayout" initial={false}>
          <motion.span
            key={v}
            initial={{ y: "100%", opacity: 0 }}
            animate={{ y: "0%", opacity: 1 }}
            exit={{ y: "-100%", opacity: 0 }}
            transition={{ duration: 0.6, ease: [0.76, 0, 0.24, 1] }}
            className="block font-serif text-[16vw] font-light leading-none tracking-tight text-deep-black md:text-[11vw] lg:text-[9rem]"
          >
            {v}
          </motion.span>
        </AnimatePresence>
      </div>
      <span className="mt-3 text-[10px] uppercase tracking-[0.4em] text-gold-soft md:text-xs">{label}</span>
    </div>
  );
}

export default function Chapter2Countdown({ config }) {
  const t = useCountdown(config.weddingDate);
  return (
    <section className="relative bg-champagne py-28 md:py-40" data-testid="chapter-2">
      <div className="mx-auto max-w-6xl px-6 md:px-16">
        <ChapterTag n={1} title="La cuenta regresiva" />
        <Reveal>
          <h2 className="mb-16 max-w-2xl font-serif text-4xl font-light leading-tight tracking-tight text-deep-black md:text-6xl">
            Hasta que digamos <span className="italic text-gold-soft">{'\u201Cacepto\u201D'}</span>.
          </h2>
        </Reveal>
        <div className="grid grid-cols-2 gap-x-6 gap-y-12 md:grid-cols-4 md:gap-4">
          <Unit value={t.days} label="Días" />
          <Unit value={t.hours} label="Horas" />
          <Unit value={t.minutes} label="Minutos" />
          <Unit value={t.seconds} label="Segundos" />
        </div>
      </div>
    </section>
  );
}
